"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITemplateType = exports.IWhatsAppTypeEnum = void 0;
/**
 * Enum representing different WhatsApp providers.
*/
var IWhatsAppTypeEnum;
(function (IWhatsAppTypeEnum) {
    IWhatsAppTypeEnum["GUPSHUP"] = "gupshup";
    IWhatsAppTypeEnum["TWILIO"] = "twilio";
    IWhatsAppTypeEnum["SINCH"] = "sinch";
    IWhatsAppTypeEnum["ACL"] = "acl";
    IWhatsAppTypeEnum["KARIX"] = "karix"; // Enum member for Karix WhatsApp provider
})(IWhatsAppTypeEnum = exports.IWhatsAppTypeEnum || (exports.IWhatsAppTypeEnum = {}));
/**
 * Enum representing different types of templates.
*/
var ITemplateType;
(function (ITemplateType) {
    /**
     * Template type for media-related content.
     * This includes images, videos, or other multimedia formats.
    */
    ITemplateType["MEDIA"] = "media";
    ITemplateType["TEXT"] = "text";
    ITemplateType["FILE"] = "file";
    ITemplateType["VIDEO"] = "video";
})(ITemplateType = exports.ITemplateType || (exports.ITemplateType = {}));
